export const bridges = [
  {
    id: "zhaozhou",
    name: "Zhaozhou Bridge",
    zh: "赵州桥",
    year: 605,
    location: "Hebei, China",
    img: "/images/webp/zhaozhou.webp",
    gallery: ["/images/webp/zhaozhou.webp",
              "/images/webp/zhaozhou2.webp",
             "/images/webp/zhaozhou3.webp",
              "/images/webp/zhaozhou4.webp",
              "/images/webp/zhaozhou5.webp",
              "/images/webp/zhaozhou6.webp",
              "/images/webp/zhaozhou7.webp",
              "/images/webp/zhaozhou8.webp",
              "/images/webp/zhaozhou9.webp",
             "/images/webp/zhaozhou10.webp",
             "/images/webp/zhaozhou11.webp",
             "/images/webp/zhaozhou12.webp",
            ],
    desc_en: `A famous ancient stone arch bridge in Hebei, known for its elegant engineering.

Zhaozhou Bridge, built in 605 during the Sui dynasty, is one of the most celebrated bridges in Chinese history and is widely regarded as the earliest surviving open-spandrel stone arch bridge in the world.

What makes it visually distinctive is the lightness of its structure. Instead of appearing heavy and solid, the main arch is accompanied by smaller openings in the shoulders, giving the bridge a more graceful and airy profile than many earlier stone bridges.

This design was not only elegant but also technically innovative. It reduced the weight of the structure, improved drainage and flood performance, and helped distribute pressure more efficiently.

For that reason, Zhaozhou Bridge is often discussed as a landmark in the global history of bridge engineering. Its long survival through floods, earthquakes, and centuries of use has made it a symbol of both structural intelligence and artistic refinement in ancient China.`,
    desc_zh: `赵州桥是中国著名的古代石拱桥，以精巧的工程设计闻名。
    
    赵州桥建于公元605年，是中国古代桥梁工程中最具代表性的作品之一。
    
    从图片中可以看到，它的主拱线条非常舒展，桥体比例轻巧，和普通厚重的石桥明显不同。 
    
    这座桥最重要的特点是敞肩式结构，也就是在大拱两侧开出小拱洞，这样既能减轻桥身重量，也能帮助泄洪和分散压力。
    
    正因为这种设计，它常被视为中国古代桥梁技术突破性的成果。 历经洪水、地震与长期使用后，赵州桥依然保存良好。
    
    它不仅是一座桥，更像是一件把结构美感与工程智慧结合在一起的石作杰作。`
  },
  {
    id: "lugou",
    name: "Lugou Bridge",
    zh: "卢沟桥",
    year: 1192,
    location: "Beijing, China",
    img: "/images/webp/lugou.webp",
    gallery: ["/images/webp/lugou.webp",
              "/images/webp/lugou2.webp",
              "/images/webp/lugou3.webp",
              "/images/webp/lugou4.webp",
              "/images/webp/lugou5.webp",
              "/images/webp/lugou6.webp",
              "/images/webp/lugou7.webp",
              "/images/webp/lugou8.webp",
              "/images/webp/lugou9.webp",
              "/images/webp/lugou10.webp",
              "/images/webp/lugou11.webp",
              "/images/webp/lugou12.webp",
              "/images/webp/lugou13.webp",
              "/images/webp/lugou14.webp",
            ],
    desc_en: `A historic stone bridge in BEIJING  known for its carved lions and cultural significance.

    Lugou Bridge, also known internationally as the Marco Polo Bridge, began construction in 1189 and was completed in 1192.

    It is one of Beijing's most important historic bridges and is especially well known for the stone lions that line its balustrades. 
    
    These carved lions are the bridge's most memorable visual feature. Their different poses, expressions, and sizes give the bridge a strong sculptural identity and make it far more than a purely functional crossing. 
    
    The bridge also occupies an important place in both Chinese and global historical memory. 
    
    Marco Polo's account helped make it famous abroad, while the Marco Polo Bridge Incident of 1937 gave it major significance in modern Chinese history. 

    Structurally and artistically, Lugou Bridge remains one of the clearest surviving examples of a major northern stone bridge from the Jin and later Qing restoration tradition.`,
    desc_zh: `卢沟桥是北京著名的历史石桥，以桥上的石狮和历史意义闻名。
    
    卢沟桥建于1189年，是北京地区最有代表性的古桥之一。
    
    照片里最吸引人的往往不是桥面本身，而是栏杆上成排分布的石狮，它们让整座桥有很强的历史辨识度。
    
    这座桥因马可·波罗的记述而广为西方世界所知，后来又因近代中国历史中的重要事件而具有更深的纪念意义。
    
    因此，卢沟桥既是一处古代建筑，也是一处历史现场。
    
    从结构上看，它体现了金代成熟的石桥营造技术；从视觉上看，桥身平稳舒展，石栏、望柱和石狮共同构成了极具层次感的景观。`
  },
  {
    id: "guangji",
    name: "Guangji Bridge",
    zh: "广济桥",
    year: 1171,
    location: "Guangdong, China",
    img: "/images/webp/guangji.webp",
    gallery: ["/images/webp/guangji.webp",
               "/images/webp/gauangji2.webp",
               "/images/webp/guangji3.webp",
               "/images/webp/guangji4.webp",
               "/images/webp/guangji5.webp",
               "/images/webp/guangji6.webp",
               "/images/webp/guangji7.webp",
               "/images/webp/guangji8.webp",
               "/images/webp/guangji9.webp",
               "/images/webp/guangji10.webp",
               "/images/webp/guangji11.webp",
              "/images/webp/guangji12.webp",
              "/images/webp/guangji13.webp",
              "/images/webp/guangji14.webp",
              "/images/webp/guanji15.webp",
            ],
    desc_en: `A famous old bridge in Guangdong with a unique mixed structure.
    Guangji Bridge in Chaozhou is one of the most unusual historic bridges in China because it combines fixed bridge sections with a floating pontoon section. 
    
    First built in 1170, it is often listed among China's great ancient bridges. 
    
    Its importance lies in this hybrid structure. Rather than being a conventional stone bridge throughout, it was designed to respond to the navigational needs of the Han River by allowing part of the crossing to be opened or adjusted. 
    
    This gave Guangji Bridge a very different relationship to urban life and river traffic than most monumental bridges. 
    
    It served commerce, circulation, and symbolic identity all at once. 
    
    Today it is valued not only as a feat of engineering but also as one of the strongest cultural symbols of Chaozhou.`,
    desc_zh: `广济桥是广东著名古桥，以独特的桥梁结构闻名。
    广济桥是潮州最具代表性的地标之一，也是中国古桥中结构最特别的桥梁之一。
    
    它不是单纯的一种桥式，而是将固定桥段与可变动的浮桥段结合起来，因此从画面上就能感到它和普通石桥很不一样。
    
    这种设计直接回应了韩江通航的需求，桥的一部分可以根据河道交通进行调整，所以广济桥既有工程巧思，也有很强的城市生活意味。 
    
    今天人们提到广济桥，往往不只是在谈桥梁本身，而是在谈潮州历史、商业往来和地方文化记忆。`
  },
  {
  id: "anping",
  name: "Anping Bridge",
  zh: "安平桥",
  year: 1138,
  location: "Quanzhou, Fujian, China",
  img: "/images/webp/anping.webp",
  gallery: [
    "/images/webp/anping.webp",
    "/images/webp/anping2.webp",
    "/images/webp/anping3.webp",
    "/images/webp/anping4.webp",
    "/images/webp/anping5.webp",
    "/images/webp/anping6.webp",
    "/images/webp/anping7.webp",
    "/images/webp/anping8.webp",
    "/images/webp/anping9.webp",
    "/images/webp/anping10.webp",
    "/images/webp/anping11.webp",
    "/images/webp/anping12.webp",
    "/images/webp/anping13.webp",
    "/images/webp/anping14.webp",
],
  desc_en: `Anping Bridge, also known as Wuli Bridge, began construction in 1138 during the Southern Song dynasty and was completed in the mid-12th century. 
  
  It is one of the most important long-span historic bridges in Fujian and is often described as China's longest surviving ancient stone beam bridge.
  
  Unlike dramatic arch bridges, Anping Bridge is distinguished by length, rhythm, and engineering endurance. Its deck stretches across what was once a tidal estuary, carried by a long sequence of stone piers and massive stone beams.
  
  The bridge played an important role in connecting transport routes in the Quanzhou region, an area deeply tied to maritime trade during the Song and Yuan periods. For this reason, Anping Bridge is significant not only as infrastructure, but also as part of the wider historical transportation network of Quanzhou. 
  
  Its monumental horizontal form gives it a very different visual identity from garden bridges or arch bridges, making it one of the clearest examples of large-scale stone beam construction in premodern China.`,
  desc_zh: `安平桥又称“五里桥”，始建于南宋绍兴八年（1138年），后于12世纪中期建成，是福建乃至中国古代桥梁史上极具代表性的长梁式石桥之一。 
  
  与赵州桥、玉带桥这类以拱形著称的桥不同，安平桥最震撼人的地方在于“长”。
  
  它横跨原本的潮汐水域，桥墩与石梁连续铺展，形成极强的节奏感和延展感，因此在视觉上非常壮阔。 从交通意义上看，安平桥连接了泉州周边的重要通道，而泉州在宋元时期又是海上贸易极其繁盛的地区，因此这座桥不仅是一处地方性古桥，也是区域交通网络的重要组成部分。
  
  安平桥的价值在于，它让人看到中国古代桥梁并不只有拱桥成就，梁式石桥同样可以在尺度、技术和景观气势上达到惊人的高度。`
},
{
  id: "yongtong",
  name: "Yongtong Bridge",
  zh: "永通桥",
  year: 727,
  location: "Hebei, China",
  img: "/images/webp/yongtong.webp",
  gallery: ["/images/webp/yongtong.webp",
            "/images/webp/yongtong2.webp",
            "/images/webp/yongtong3.webp",
            "/images/webp/yongtong4.webp",
            "/images/webp/yongtong5.webp",
            "/images/webp/yongtong6.webp",
            "/images/webp/yongtong7.webp",
            "/images/webp/yongtong8.webp",
            "/images/webp/yongtong9.webp",
            "/images/webp/yongtong10.webp",
            "/images/webp/yongtong11.webp",
            "/images/webp/yongtong12.webp",
  ],
  desc_en: `An early stone arch bridge influenced by the engineering techniques of Zhaozhou Bridge.
  
  Yongtong Bridge, dating to the Tang period, is valued as an example of early mature stone arch construction in China. 
  
  Compared with later bridges that emphasize refinement and scenic elegance, Yongtong Bridge presents a more solid and restrained appearance. 
  
  That visual heaviness reflects the structural priorities of an earlier stage in stone bridge development. 
  
  Its significance lies in showing how arch construction evolved toward greater stability, durability, and long-term performance. 
  
  Bridges like Yongtong help bridge the historical gap between experimental early forms and later celebrated masterpieces. 
  
  As a result, it is important not only as a preserved monument but also as evidence of the developmental history of Chinese bridge engineering.`,
  desc_zh: `受赵州桥影响的早期石拱桥之一.
  
  永通桥约建于唐代，是中国早期成熟石拱桥的重要实例之一。
  与一些后期造型更轻巧的桥相比，它给人的感觉更厚实、更稳重，体现了早期石桥对结构安全的重视。 
  
  从照片中往往可以看到桥身整体比较朴实，没有过多装饰，但正是这种简洁让拱券、桥面和石材本身更突出。 
  
  永通桥的价值在于，它帮助人们理解中国古代石桥从经验建造逐渐走向成熟技术的过程。`
},
{
  id: "baodai",
  name: "Baodai Bridge",
  zh: "宝带桥",
  year: 816,
  location: "Suzhou, China",
  img: "  /images/webp/baodai.webp",
  gallery: ["/images/webp/baodai.webp",
            "/images/webp/baodai2.webp",
            "/images/webp/baodai3.webp",
            "/images/webp/baodai4.webp",
            "/images/webp/baodai5.webp",
            "/images/webp/baodai6.webp",
            "/images/webp/baodai7.webp",
            "/images/webp/baodai8.webp",
            "/images/webp/baodai9.webp",
            "/images/webp/baodai10.webp",
            "/images/webp/baodai11.webp",
            "/images/webp/baodai12.webp",
  ],
  desc_en: `A long multi-arch stone bridge known for its elegant design and scenic canal setting.
  
  Baodai Bridge, first built in 816 in Suzhou, is one of China's best-known multi-arch stone bridges. 
  
  Its long, low body and repeated sequence of small arches create the appearance of a ribbon laid across the water. 
  
  That elongated form is not only visually striking but also practical. 
  
  The many openings help regulate water flow and allow movement through a canal-rich environment, making the bridge especially well suited to the hydraulic landscape of Jiangnan. 
  
  Because of this, Baodai Bridge is often admired as both infrastructure and scenery. 
  
  It embodies the refined balance between engineering, waterways, and visual rhythm that characterizes much of Suzhou's historic environment. 
  
  Its reputation today rests on that combination of elegance, water management, and enduring regional identity.`,
  desc_zh: `以优雅设计和运河风景著称的多孔石桥。
  
  宝带桥建于唐代，是苏州最具识别度的古桥之一。
  
  图片中最明显的特点就是桥身极长、拱洞连续排列，远看像一条横卧水面的丝带，这也是“宝带桥”视觉魅力的来源。 
  
  它由很多小拱连接而成，这种多孔布局既让桥体有节奏感，也有利于通水和行船。对于江南水网地区来说，这类桥梁不仅承担交通功能，也和周边水环境密切配合。 
  
  宝带桥之所以常被提起，不只是因为它古老，更因为它把水利、交通与景观审美结合得非常完整，是典型的江南桥梁形象。`
},
{
  id: "luoyang",
  name: "Luoyang Bridge",
  zh: "洛阳桥",
  year: 1059,
  location: "Quanzhou, Fujian, China",
  img: "/images/webp/luoyang.webp",
  gallery: ["/images/webp/luoyang.webp",
            "/images/webp/luoyang2.webp",
            "/images/webp/luoyang3.webp",
            "/images/webp/luoyang4.webp",
            "/images/webp/luoyang5.webp",
            "/images/webp/luoyang6.webp",
            "/images/webp/luoyang7.webp",
            "/images/webp/luoyang8.webp",
            "/images/webp/luoyang9.webp",
            "/images/webp/luoyang10.webp",
            "/images/webp/luoyang11.webp",
            "/images/webp/luoyang12.webp",
  ],
  desc_en: `A pioneering sea-crossing stone beam bridge using raft foundation technology.
  
  Luoyang Bridge, completed in 1059 in Quanzhou, is one of the most important bridges in the history of Chinese marine engineering. 
  
  Unlike inland arch bridges, it was built across tidal estuary conditions where water movement and foundation stability were constant challenges. 
  
  Its fame comes largely from the engineering methods used during construction. 
  
  Historical accounts describe techniques such as strengthening the bridge base with oyster growth and carefully adapting the structure to changing tides and soft underwater conditions. 
  
  This gave the bridge importance far beyond local transportation. 
  
  It became a critical link in Quanzhou, one of the great port cities of the Song-Yuan period, and formed part of the broader historical environment associated with maritime trade. 
  
  Luoyang Bridge is therefore valued not just as an old bridge, but as an early and highly sophisticated response to coastal construction problems.`,
  desc_zh: `采用筏形基础技术建造的跨海石梁桥。
  
  洛阳桥建于北宋时期，是中国古代跨海桥梁中的代表作。
  
  与内陆拱桥相比，它给人的视觉印象更平稳、开阔，桥体与海湾、潮水环境的关系特别明显。 
  
  它最值得关注的不是单一的装饰，而是建桥环境本身。
  
  洛阳桥修建在潮汐水域中，古代工匠为稳定桥基，采用了非常有名的海洋工程方法，这使它在中国桥梁史上占有独特地位。 
  
  从交通意义看，它长期连接泉州沿海交通与贸易往来；从工程意义看，它展示了中国古人面对海潮、水流和软基条件时的适应能力。
  `
},
{
  id: "wanan",
  name: "Wan'an Bridge",
  zh: "万安桥",
  year: 1138,
  location: "Fujian, China",
  img: "/images/webp/wan'an.webp",
  gallery: ["/images/webp/wan'an.webp",
             "/images/webp/wan'an2.webp",
             "/images/webp/wan'an3.webp",
             "/images/webp/wan'an4.webp",
             "/images/webp/wan'an5.webp",
             "/images/webp/wan'an6.webp",
             "/images/webp/wan'an7.webp",
             "/images/webp/wan'an8.webp",
             "/images/webp/wan'an9.webp",
             "/images/webp/wan'an10.webp",
             "/images/webp/wan'an11.webp",
             "/images/webp/wan'an12.webp",

  ],
  desc_en: `A traditional wooden covered bridge reflecting ancient craftsmanship and community design.
  
  Wan'an Bridge is a traditional covered wooden corridor bridge associated with southern Chinese architectural traditions. 
  
  Rather than functioning as a bare crossing, it incorporates a roofed passage that turns the bridge into a shared public space. 
  
  This design offered practical protection from rain and sun, but it also supported conversation, rest, and community interaction. 
  
  In that sense, the bridge belongs as much to daily social life as to transport infrastructure. 
  
  Its wooden structure and built enclosure distinguish it sharply from stone arches such as -those in northern or imperial settings. 
  
  Wan'an Bridge is therefore an excellent example of how local environment, material tradition, and communal life shaped bridge design in southern China.`,
  desc_zh: `展现传统工艺和社区设计的木质廊桥。
  
  万安桥是一座典型的南方木构廊桥。
  
  和石桥相比，它最容易被认出的地方是桥上覆盖着廊屋，这让桥不只是过河设施，也像一条跨水而建的街巷。 
  
  这样的结构非常适合多雨潮湿的环境，行人可以在桥上避风雨、停留、交谈，因此桥梁本身也成为社区生活的一部分。
  
  从图像角度看，万安桥最有魅力的就是木构、屋顶和河道共同形成的层次感，它体现了南方桥梁“可行、可停、可聚”的生活属性。`
},
{
  id: "tongji",
  name: "Tongji Bridge",
  zh: "通济桥",
  year: 1190,
  location: "Guangdong, China",
  img: "/images/webp/tongji.webp",
  gallery: ["/images/webp/tongji.webp",
            "/images/webp/tongji2.webp",
            "/images/webp/tongji3.webp",
            "/images/webp/tongji4.webp",
            "/images/webp/tongji5.webp",
            "/images/webp/tongji6.webp",
            "/images/webp/tongji7.webp",
            "/images/webp/tongji8.webp",
            "/images/webp/tongji9.webp",
            "/images/webp/tongji10.webp",
            "/images/webp/tongji11.webp",
            "/images/webp/tongji12.webp",
  ],
  desc_en: `A historic arch bridge associated with cultural traditions and local festivals.
  
  Tongji Bridge is remembered not only as a crossing but also as a bridge deeply connected with local ritual life and seasonal custom in southern China. 
  
  Bridges of this kind often became gathering spaces where movement, commerce, and civic identity overlapped. 
  
  That cultural role helps explain why Tongji Bridge remains meaningful beyond its practical transport function. 
  
  Visually, its historical value is tied to its place within a larger riverside settlement rather than to a single dramatic structural gesture. 
  
  It stands as an example of how many Chinese bridges became woven into the ceremonial and emotional life of their communities.`,
  desc_zh: `与地方文化和节日密切相关的历史拱桥。
  
  通济桥是岭南地区很有代表性的古桥之一。
  
  它的意义不仅在于跨越水面、连接道路，更在于长期参与地方节庆与集体记忆，所以人们对它的感受常常带有生活气息与仪式感。 
  
  从视觉上看，这类桥梁往往与周边河道、街市和人流共同构成城市景观，并不是孤立存在的建筑物。 
  
  因此，通济桥值得关注的不只是桥体本身，更是它在地方文化中所扮演的“连接”角色。`
},
{
  id: "shunji",
  name: "Shunji Bridge",
  zh: "顺济桥",
  year: 1200,
  location: "China",
  img: "/images/webp/shunji.webp",
  gallery: ["/images/webp/shunji.webp",
            "/images/webp/shunji2.webp",
            "/images/webp/shunji3.webp",
            "/images/webp/shunji4.webp",
            "/images/webp/shunji5.webp",
            "/images/webp/shunji6.webp",
            "/images/webp/shunji7.webp",
            "/images/webp/shunji8.webp",
            "/images/webp/shunji9.webp",
            "/images/webp/shunji10.webp",
  ],
  desc_en: `An ancient stone bridge reflecting early Chinese engineering and regional design.
  
  Shunji Bridge represents a more regional and workaday form of historic bridge building in China. 
  
  It is not famous because of extreme scale or imperial context, but because it reflects durable local construction serving real everyday needs. 
  
  Its appearance is comparatively plain, and that simplicity is part of its value. 
  
  The bridge emphasizes reliability, connection, and daily use over ceremonial display. 
  
  Historically, such bridges supported movement between villages, markets, and agricultural communities, making them central to local social and economic life. 
  
  Shunji Bridge therefore reminds us that Chinese bridge heritage includes not only iconic masterpieces but also regionally important bridges that sustained ordinary life.`,
  desc_zh: `体现早期中国工程技术和地域设计的古桥。
  
  顺济桥体现的是一种更贴近日常生活的地方桥梁形象。
  
  它不像皇家园林桥那样强调装饰，也不像名胜古桥那样以传奇闻名，而是通过稳定、实用的结构承担真实的通行任务。 
  
  从照片和整体气质来看，它的特色在于简洁与耐久，这种朴素感恰恰反映了地方桥梁服务社区、服务贸易的实际用途。 
  
  顺济桥的价值在于让人看到，中国古桥遗产并不只有“名桥”，也包括大量支撑地方社会运行的普通而重要的桥梁。`
},
{
  id: "jinshui",
  name: "Jinshui Bridge",
  zh: "金水桥",
  year: 1420,
  location: "Beijing, China",
  img: "/images/webp/jinshui.webp",
  gallery: ["/images/webp/jinshui.webp",
            "/images/webp/jinshui2.webp",
            "/images/webp/jinshui3.webp",
            "/images/webp/jinshui4.webp",
            "/images/webp/jinshui5.webp",
            "/images/webp/jinshui6.webp",
            "/images/webp/jinshui7.webp",
            "/images/webp/jinshui8.webp",
            "/images/webp/jinshui9.webp",
            "/images/webp/jinshui10.webp",
            "/images/webp/jinshui11.webp",
            "/images/webp/jinshui12.webp",
  ],
  desc_en: `Located in the Forbidden City, these bridges symbolize imperial authority and architectural symmetry.
  
  Jinshui Bridge belongs to the ceremonial architectural sequence of the Forbidden City in Beijing and should be understood within the logic of imperial space rather than ordinary transportation. 
  
  Its white stone construction, symmetrical layout, and alignment with palace axes contribute to a formal and highly ordered visual effect. 
  
  In this setting, the bridge participates in hierarchy, ritual, and political symbolism. 
  
  Unlike bridges shaped mainly by geography or hydraulic need, Jinshui Bridge is shaped by court design and ceremonial procession. 
  
  It is therefore significant as a bridge, but also as an integral element of one of the most carefully composed imperial architectural ensembles in China.`,
  desc_zh: `位于紫禁城内，象征皇权与建筑对称之美。
  
  金水桥位于紫禁城前部区域，是典型的宫廷礼仪空间组成部分。
  
  和民间桥梁不同，它更强调秩序、等级与中轴对称，所以从画面上看会显得非常规整庄重。 
  
  桥体多用汉白玉等石材建成，栏杆、桥面与周边宫殿建筑共同构成了皇家建筑特有的仪式感。 
  
  金水桥的重要性不仅在于过水功能，更在于它是皇城空间序列中的一部分，代表着传统宫廷建筑的礼制审美。`
},
{
  id: "shuangqiao",
  name: "Shuangqiao (Double Bridge)",
  zh: "双桥",
  year: 1573,
  location: "Zhouzhuang, China",
  img: "/images/webp/shauangqiao.webp",
  gallery: ["/images/webp/shauangqiao.webp",
            "/images/webp/shuangqiao2.webp",
            "/images/webp/shuangqiao3.webp",
            "/images/webp/shuangqiao4.webp",
            "/images/webp/shuangqiao5.webp",
            "/images/webp/shuangqiao6.webp",
            "/images/webp/shuangqiao7.webp",
            "/images/webp/shuangqiao8.webp",
            "/images/webp/shuangqiao9.webp",
            "/images/webp/shuangqiao10.webp",
  ],
  desc_en: `A picturesque pair of bridges forming a unique cross-shaped waterway in a historic town.
  
  Shuangqiao, or the Double Bridge, is a classic Jiangnan waterside composition formed by two connected bridges crossing different channels in Suzhou. 
  
  Its importance lies less in monumental engineering than in spatial atmosphere. 
  
  The bridges, waterways, houses, and reflections together create a scene that has become one of the most recognizable visual symbols of the Jiangnan water town. 
  
  Because of this, Shuangqiao appears frequently in painting, photography, and travel imagery.
  
  It is admired for the way it turns everyday circulation into an elegant built landscape. 
  
  The bridge group is best understood as part of a lived waterside environment rather than as a single isolated monument.`,
  desc_zh: `两座桥交错形成独特水道景观的古镇名桥。
  
  双桥是江南水乡景观中非常经典的一组桥梁形象。
  
  照片里常能看到两座桥与河道、白墙灰瓦民居一起出现，这种组合本身就很像一幅传统水乡画。 
  
  它的特别之处在于并不是单独一座桥，而是两座桥配合不同水路与巷道形成连续空间，所以观看时更容易感受到“小桥、流水、人家”的生活气息。 
  
  双桥之所以常被画家和游客反复描绘，正是因为它把江南建筑、水面反光与日常生活场景结合得非常自然。`
},
{
  id: "taiping",
  name: "Taiping Bridge",
  zh: "太平桥",
  year: 1600,
  location: "Anhui, China",
  img: "/images/webp/taiping.webp",
  gallery: ["/images/webp/taiping.webp",
            "/images/webp/taiping2.webp",
            "/images/webp/taiping3.webp",
            "/images/webp/taiping4.webp",
            "/images/webp/taiping5.webp",
            "/images/webp/taiping6.webp",
            "/images/webp/taiping7.webp",
            "/images/webp/taiping8.webp",
            "/images/webp/taiping9.webp",
            "/images/webp/taiping10.webp",
  ],
  desc_en: `A traditional stone bridge symbolizing peace and stability in ancient communities.
  
  Taiping Bridge is best appreciated in relation to its surrounding landscape. 
  
  Rather than standing out through highly specialized engineering, it is remembered for the way it integrates with its setting and traditional travel routes. 
  
  Historically, it helped connect local movement and commerce, giving it practical significance beyond its scenic image. 
  
  At the same time, the bridge reads strongly as part of a broader landscape composition, where water, settlement, and crossing form a unified view. 
  
  This balance between utility and atmosphere gives Taiping Bridge its lasting appeal.`,
  desc_zh: `象征和平与稳定的传统石桥。
  
  太平桥常常给人一种“景在桥中、桥在景中”的感觉。
  
  相比强调复杂结构的名桥，它更突出的魅力在于桥与周边环境的融合，适合在整体风景中观看。 
  
  历史上，它承担过地方交通和商旅往来的功能，因此并不是单纯的观景设施，而是和区域发展联系在一起的桥梁。 
  
  今天再看太平桥，人们往往会同时看到它的实用历史和它作为传统景观元素的美感。`
},
{
  id: "yudai",
  name: "Jade Belt Bridge",
  zh: "玉带桥",
  year: 1751,
  location: "Beijing, China",
  img: "/images/webp/jadebelt.webp",
  gallery: ["/images/webp/jadebelt.webp",
            "/images/webp/jadebelt2.webp",
            "/images/webp/jadebelt3.webp",
            "/images/webp/jadebelt4.webp",
            "/images/webp/jadebelt5.webp",
            "/images/webp/jadebelt6.webp",
            "/images/webp/jadebelt7.webp",
            "/images/webp/jadebelt8.webp",
            "/images/webp/jadebelt9.webp",
            "/images/webp/jadebelt10.webp",
            "/images/webp/jadebelt11.webp",
            "/images/webp/jadebelt12.webp",
            "/images/webp/jadebelt13.webp",
            "/images/webp/jadebelt14.webp",
  ],
  desc_en: `A highly arched marble bridge in the Summer Palace, known for its elegant curve.
  
  Jade Belt Bridge, also known as Yudai Bridge, was built during the Qianlong period of the Qing Dynasty, generally dated to 1750 and sometimes recorded as 1751. 
  
  It stands on the West Causeway of Kunming Lake in the Summer Palace, Beijing, and is the most visually dramatic bridge among the West Causeway bridges. 
  
  Its defining feature is the single, very high arch that rises sharply above the water, giving the bridge the shape of an upward-curving jade belt. 
  
  Built with white marble and pale stone, the bridge contrasts beautifully with the lake surface and becomes especially striking in clear light. 
  
  The balustrades, posts, and carved details reflect the refined stone craftsmanship of the Qing imperial garden tradition. 
  
  The high arch was not only aesthetic. It was also designed to allow large imperial boats to pass underneath when the Qianlong Emperor traveled by water toward Yuquan Mountain. 
  
  In this sense, the bridge combines navigation function with landscape composition. 
  
  Historically, the bridge belongs to the original construction phase of Qingyi Garden, the predecessor of the Summer Palace. 
  
  It was damaged after the destruction of the garden in 1860 and later restored during the Guangxu-era rebuilding of the Summer Palace. 
  
  Today, it remains one of the signature landmarks of Kunming Lake. 
  
  Artistically, Jade Belt Bridge is a classic example of Chinese imperial garden design. 
  
  It breaks the flat line of the causeway with a single elegant arc, linking water, embankment, willow trees, and distant hills into one composed scene. 
  
  Its form has made it one of the most iconic garden bridges in China.`,
  
  desc_zh: `位于颐和园的高拱大理石桥，以优美曲线著称。
  
  玉带桥建于清乾隆十五年（公元1750年，亦有资料记为1751年），位于北京颐和园昆明湖西堤，是西堤六桥中造型最醒目、识别度最高的一座桥。 
  
  它是一座单孔高拱石桥，桥身高高拱起，弧线流畅舒展，整体形似一条向上挑起的玉带，这是它最鲜明的视觉标识。
  
  桥体以汉白玉和青白石砌筑而成，洁白桥身与湖水、堤岸、垂柳形成强烈而优雅的对比。
  
  桥栏望柱、纹饰雕刻以及石狮细节，也体现了清代皇家园林石作工艺的精巧水准。
  
  这种高拱造型并不只是为了好看。乾隆皇帝曾乘御舟由昆明湖前往玉泉山，高耸的拱券能够让较高的船只顺利通过桥下，因此玉带桥同时兼顾了通航需求与景观效果。 
  
  从历史沿革来看，玉带桥始建于清漪园营建时期，是西堤六桥中唯一的高拱桥。1860年清漪园遭焚后，玉带桥曾受损，后在光绪年间重建颐和园时按原样修复，所以今天所见仍保持着清代皇家园林桥梁的整体风貌。 
  
  在园林艺术上，玉带桥是“借景”与“造景”结合的典型范例。
  
  它以一条强烈而优美的弧线打破西堤的平直走势，把湖面、堤岸、柳树和远山串联成富有节奏感的构图，也因此成为中国古典园林桥梁中极具代表性的经典形象。`
},
{
  id: "nine-dragon",
  name: "Nine-Dragon Bridge",
  zh: "九龙桥",
  year: 1700,
  location: "Beijing, China",
  img: "/images/webp/ninedragon.webp",
  gallery: ["/images/webp/ninedragon.webp",
            "/images/webp/ninedragon2.webp",
            "/images/webp/ninedragon3.webp",
            "/images/webp/ninedragon4.webp",
            "/images/webp/ninedragon5.webp",
            "/images/webp/ninedragon6.webp",
            "/images/webp/ninedragon7.webp",
  ],
  desc_en: `A decorative bridge featuring dragon motifs symbolizing power and protection.
  
  This entry refers to the Nine-Dragon Bridge associated with the imperial garden setting in Beijing, not the Hong Kong Kowloon district. 
  
  The name is therefore rendered as "Nine-Dragon Bridge" rather than "Kowloon Bridge" to avoid confusion. 
  
  Its significance lies more in symbolic meaning, landscape composition, and decorative imperial garden context than in large structural scale. 
  
  It belongs to a world of courtly scenery rather than to the category of major transport bridges. 
  
  Because online image attribution for this bridge is frequently confused with unrelated landmarks, the project intentionally uses a neutral fallback image unless a verified bridge photograph is available. 
  
  That decision helps preserve informational accuracy instead of presenting a visually attractive but incorrect image association.`,
  desc_zh: `以龙纹装饰为特色，象征力量与守护。
  
  这里的“九龙桥”指的是北京皇家园林语境中的九龙桥，不是香港“九龙”的英文地名对应桥梁，因此英文名称采用更准确的 “Nine-Dragon Bridge”，以避免误解。 
  
  这座桥的价值主要体现在园林景观、皇家语境和装饰象征意义上，而不是像大型名桥那样以跨度或复杂结构著称。 
  
  考虑到网络上对“九龙桥”图片归属常有混淆，本项目在未确认图片准确来源前，刻意改为使用中性占位图，避免错误指认。`
},
{
  id: "fengyu",
  name: "Fengyu Bridge",
  zh: "风雨桥",
  year: 1910,
  location: "Guizhou, China",
  img: "/images/webp/fengyu.webp",
  gallery: ["/images/webp/fengyu.webp",
            "/images/webp/fengyu2.webp",
            "/images/webp/fengyu3.webp",
            "/images/webp/fengyu4.webp",
            "/images/webp/fengyu5.webp",
            "/images/webp/fengyu6.webp",
            "/images/webp/fengyu7.webp",
            "/images/webp/fengyu8.webp",
            "/images/webp/fengyu9.webp",
            "/images/webp/fengyu10.webp",
            "/images/webp/fengyu11.webp",
            "/images/webp/fengyu12.webp",

  ],
  desc_en: `A covered wooden bridge built by the Dong people, combining function, shelter, and beauty.
  
  Fengyu Bridge is a traditional covered bridge associated with the Dong ethnic group and is one of the most recognizable forms of minority wooden architecture in southwest China. 
  
  Its roofed corridor transforms the bridge into more than a passage. 
  
  It serves as shelter, meeting place, resting point, and social space, giving the bridge a strong communal dimension. 
  
  Architecturally, the combination of timber framing, layered roof forms, and decorated passageway creates a structure that reads almost like a building stretched across water. 
  
  Fengyu Bridge is therefore important as both vernacular engineering and living cultural space.`,
  desc_zh: `侗族建造的廊桥，集通行、避雨与美观于一体。
  
  风雨桥是侗族传统建筑中非常有代表性的桥梁形式。
  
  它最直观的视觉特点就是桥上覆盖着廊屋，远看更像一座横跨水面的木构建筑，而不是单纯的桥。 
  
  这种桥不只服务于通行，还为人们提供遮风避雨、歇脚和社交的空间，所以“风雨桥”本身就带有浓厚的生活气息。 
  
  从建筑文化角度看，风雨桥把结构、装饰与民族日常生活结合在一起，是中国少数民族木构建筑智慧的重要体现。`
},
{
 id: "Qinghua",
  name: "Qinghua Rainbow Bridge",
  zh: "清华彩虹桥",
  year: 1200,
  location: "Jiangxi, China",
  img: "/images/webp/rainbow.webp",
  gallery: ["/images/webp/rainbow.webp",
            "/images/webp/rainbow2.webp",
            "/images/webp/rainbow3.webp",
            "/images/webp/rainbow4.webp",
            "/images/webp/rainbow5.webp",
            "/images/webp/rainbow6.webp",
            "/images/webp/rainbow7.webp",
            "/images/webp/rainbow8.webp",
            "/images/webp/rainbow9.webp",
            "/images/webp/rainbow10.webp",
            "/images/webp/rainbow11.webp",
            "/images/webp/rainbow12.webp",
  ],
  desc_en: `Ancient paths, pavilions and bridges can be seen everywhere in Wuyuan, Jiangxi, including the Qinghua Rainbow Bridge, an ancient veranda bridge. 
  
  The bridge got the name from the Tang verse “The lake between the two rivers looks like a mirror, and the two bridges on the river are like two fallen rainbows.
  
  The Qinghua Bridge is a single-arch stone bridge with a length of 15.5 meters and a width of 3.5 meters. 
  
  It was built in the Song Dynasty and has been repaired several times since then. 
  
  The bridge is not only a transportation tool but also a cultural symbol of Wuyuan, reflecting the local people's love for nature and their pursuit of beauty.
  
  The 800-year-old Rainbow Bridge in Qinghua Town, Wuyuan County, in east China's Jiangxi Province was damaged by floods in 2020. 
  
  Local tourism authorities said that the deck of the bridge was partially damaged but its piers remained intact. 
  
  The Rainbow Bridge was originally built in the Southern Song Dynasty and has over 800 years of history. 
  
  It is 140 meters long and is regarded as one of the most beautiful lounge bridges in China.`,
  desc_zh: `婺源县境内古道、亭台和桥梁随处可见，其中包括古老的清华彩虹桥。这座桥的名字来源于唐代诗句：“两河之间湖水如镜，河上双桥似落彩虹。”
  
  清华桥是一座单孔石桥，长15.5米，宽3.5米。它建于宋代，此后经过多次修缮。这座桥不仅是交通工具体验，也是婺源的文化象征，体现了当地人民对自然的热爱和对美的追求。
  
  清华桥是一座单拱石桥，全长15.5米，宽3.5米。

它建于宋代，此后多次修缮。

这座桥不仅是一种交通工具，也是婺源的文化象征，体现了当地人对自然的热爱以及对美的追求。

位于中国东部江西省婺源县清华镇的拥有800年历史的彩虹桥在2020年的洪水中受损。

当地旅游部门表示，桥面部分受损，但桥墩仍然完好无损。

彩虹桥始建于南宋，已有800多年的历史。`,
},
]